export default __webpack_public_path__ + "static/media/business-identified.27542a8d.png";